<template>
  <div class="admin_category container">
    <v-card>
      <v-card-title>
        <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
        <v-divider class="mx-4" inset vertical></v-divider> 
        Your Reserves
      </v-card-title>
      <v-data-table :headers="headers" :items="reserves" :search="search" sort-by="date" class="elevation-1">
        <template v-slot:top>
          <div class="hidden-md-and-up container">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          </div>
          <v-toolbar flat color="white">
            <div class="hidden-sm-and-down">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <router-link 
            :to="{ name: 'admin_subcategory_products', 
            params: { slug: item.slug }}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <b>{{ item.name }} +</b>
                </span>
              </template>
              <span>Add Reserve Pricing</span>
            </v-tooltip>
          </router-link>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editReserve(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deleteReserve(item)"
            >
              mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
          <v-list-item-title><b>No Reserves Yet</b></v-list-item-title>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import {db} from '@/firebase';
  
  export default {
    data: () => ({
      nav_title: 'Reviews Page',
      dialog: false,
      status: [
        0,1
      ],
      priority: [
        0,1
      ],
      reserve_code: [
        'ZMK',
        'ZIM'
      ],
      town_code: [
        'LSK'
      ],
      search: '',
      headers: [
        { text: 'Reserve #', align: 'left', value: 'name' },
        { text: 'Date', align: 'left', value: 'date' },
        { text: 'Client Name | Location', value: 'priority' },
        { text: 'CartID', value: 'priority' },
        { text: 'Paid Amt', value: 'priority' },
        { text: 'Reserve Status', value: 'reserve_status' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      reserves: [],
      editedIndex: -1,
      reserve: {
        name: '',
        slug: '',
        type: '',
        description: '',
        status: '',
        priority: '',
        movements: [],
        reserve_code: [],
        town_code: []
      },
      activeItem: '',
      modal: ''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Reserve' : 'Edit Reserve'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    firestore() {
      return {
        reserves: db.collection('reserves')
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      
      reset(){
        this.reserve = {
          name: '',
          slug: '',
          type: '',
          description: '',
          status: '',
          priority: '',
          movements: [],
          reserve_code: [],
          town_code: []
        }  
      },

      addNew(){
        this.modal = 'new'
        this.reset()
        this.dialog = true
      },

      addReserve(){
        this.$firestore.reserves.add(this.reserve)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Reserve created successfully'
        })
        /* eslint-enable */
        this.close()
      },
      
      updateReserve(){
        this.$firestore.reserves.doc(this.reserve.id).update(this.reserve)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Reserve System updated successfully'
        })
        /* eslint-enable */
        this.close()
      },

      editReserve(item) {
        this.editedIndex = this.reserves.indexOf(item)
        this.reserve = Object.assign({}, item)
        this.modal = 'edit'
        this.prodialog = true
      },

      deleteReserve(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestore.reserves.doc(item.id).delete()            

            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
          }
        })
        /* eslint-enable */
      }, 

      close () {
        this.dialog = false
        setTimeout(() => {
          this.reserve = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    },
  }
</script>
